import { merge } from 'lodash';
import { getProvider } from '../vue-apollo';

class BaseAPIService {
	constructor() {
		this.provider = getProvider();
	}

	/**
	 * Send query to server.
	 * @param {String} query
	 * @param {Object} variables
	 */
	query(options) {
		return this.provider.defaultClient.query(options);
	}

	/**
	 * Send mutate to server.
	 * @param {String} query
	 * @param {Object} variables
	 */
	mutate(options) {
		return this.provider.defaultClient.mutate(options);
	}

	/**
	 * Subscribe to server.
	 * @param {String} query
	 * @param {Object} variables
	 */
	subscribe(options) {
		return this.provider.defaultClient.subscribe(options);
	}

	getArgsString(args) {
		args = merge({ limit: 10000 }, args);
		if (args) {
			const arr = [];
			for (let i in args) {
				arr.push(`${i}: ${typeof args[i] === 'String' ? `"${args[i]}"` : args[i]}`);
			}
			return arr.join(', ');
		} else {
			return '';
		}
	}

	getValue(value) {
		if (value && typeof value === 'String') {
			return value.replace('"', '"');
		} else {
			return value;
		}
	}
}

export default BaseAPIService;
